"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("@remirror/pm/model");
const react_1 = require("@remirror/react");
const dxp_ai_client_react_1 = require("@squiz/dxp-ai-client-react");
const sds_1 = require("@squiz/sds");
const prosemirror_model_1 = require("prosemirror-model");
const react_2 = __importDefault(require("react"));
const AiIcon_1 = require("../../../Icons/AiIcon");
const dxp_content_tools_modal_1 = require("@squiz/dxp-content-tools-modal");
const ContentToolsDropdown = () => {
    const aiService = (0, dxp_ai_client_react_1.useAiService)();
    const { contentTools } = aiService;
    const { updateActiveDialog } = (0, sds_1.useDialogStore)();
    const { isSelectionEmpty, getHTML } = (0, react_1.useHelpers)();
    const { getState, view } = (0, react_1.useRemirrorContext)();
    // No content tools to show, don't show dropdown at all
    if (!contentTools || contentTools?.length === 0) {
        return null;
    }
    const hasContent = getState().doc.textContent.length > 0;
    const getSelectedRichText = () => {
        const { from, to } = getState().selection;
        const fragment = getState().doc.slice(from, to).content;
        const div = document.createElement('div');
        fragment.forEach((node) => {
            div.appendChild(model_1.DOMSerializer.fromSchema(getState().schema).serializeNode(node));
        });
        return div.innerHTML;
    };
    const onInsertAfter = (content) => {
        const schema = getState().schema;
        const doc = getState().doc;
        const tr = getState().tr;
        // Parse the HTML string into a document fragment
        const element = document.createElement('div');
        element.innerHTML = content;
        const newContent = prosemirror_model_1.DOMParser.fromSchema(schema).parse(element);
        // Append the new content to the existing document
        const newTransaction = tr.insert(doc.content.size, newContent.content);
        view.dispatch(newTransaction);
    };
    const onReplace = (content) => {
        const schema = getState().schema;
        const { from, to, empty } = getState().selection;
        const { tr } = getState();
        // Parse the HTML string into a document fragment
        const element = document.createElement('div');
        element.innerHTML = content;
        const newContent = prosemirror_model_1.DOMParser.fromSchema(schema).parse(element);
        if (empty) {
            // If there is no selection, replace the entire document content
            const newTransaction = tr.replaceWith(0, getState().doc.content.size, newContent.content);
            view.dispatch(newTransaction);
        }
        else {
            // Replace the selected content with the new content
            const newTransaction = tr.replaceWith(from, to, newContent.content);
            view.dispatch(newTransaction);
        }
    };
    const dropdownItems = contentTools?.map((item) => {
        return {
            items: [
                {
                    action: () => {
                        // If we don't have a selection, use all text
                        const richContent = isSelectionEmpty() ? getHTML() : getSelectedRichText(); // NOTE: selected rich text may not work as expected
                        const dialogProps = {
                            classes: ['dxp-ctm-dialog'],
                            dialogContent: {
                                renderContent: (dialogContentProps) => {
                                    return (react_2.default.createElement(dxp_content_tools_modal_1.ModalContent, { aiServiceOverride: aiService, content: richContent, contentTool: item, dialogContentProps: dialogContentProps, onInsertAfter: onInsertAfter, onReplace: onReplace }));
                                },
                            },
                            dialogSize: sds_1.DIALOG_SIZE_XL,
                            heading: `Rewrite content to ... ${item.name}`,
                            icon: dxp_content_tools_modal_1.ICON_DXP_AI,
                            footer: react_2.default.createElement(dxp_content_tools_modal_1.ModalFooter, { contentTool: item }),
                            stateHandler: sds_1.useDialogStore,
                            showFullScreenButton: true,
                        };
                        updateActiveDialog(dialogProps);
                    },
                    key: item.id,
                    label: react_2.default.createElement("span", null, item.name),
                },
            ],
            key: item.id,
        };
    });
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.VerticalDivider, null),
        hasContent && (react_2.default.createElement(sds_1.Dropdown, { title: "Content tools", "aria-label": "Content tools", buttonProps: {
                format: sds_1.BUTTON_FORMAT_TRANSPARENT,
                icon: AiIcon_1.ICON_AI,
                theme: sds_1.BUTTON_THEME_DEFAULT,
            }, className: "content-tools-dropdown", dropdownPosition: sds_1.DROPDOWN_POSITION_RIGHT, heading: 'Rewrite to...', sections: dropdownItems ?? [], disabled: !hasContent })),
        !hasContent && react_2.default.createElement("div", { className: "content-tools-dropdown--disabled" }, AiIcon_1.ICON_AI)));
};
exports.default = ContentToolsDropdown;
